import { useI18n } from '../i18n.tsx';
import type { SourceWithFetch } from '../types.ts';

export function SourcesPanel({ sources }: { sources: SourceWithFetch[] | undefined }) {
  const { t } = useI18n();
  if (!sources) return null;

  return (
    <section className="sources">
      <h2 style={{ fontSize: 17 }}>{t.sourcesTitle}</h2>
      <p>{t.sourcesIntro}</p>

      <div className="source-grid">
        {sources.map((source) => {
          const fetched = source.lastFetch;
          return (
            <article key={source.id} className="source-card">
              <span className="name">{source.label}</span>
              <a className="url" href={source.url} target="_blank" rel="noreferrer noopener">
                {source.url.replace(/^https?:\/\//, '')}
              </a>
              <div className="row">
                <span
                  className={`badge ${fetched ? (fetched.ok ? 's-confirmed' : 's-unreachable') : 's-unverified'}`}
                >
                  <span className="dot" aria-hidden="true" />
                  {fetched ? (fetched.ok ? t.fetchOk : t.fetchFail) : t.never}
                </span>
                {fetched?.ok && (
                  <span>
                    {new Intl.NumberFormat().format(fetched.textLength ?? 0)} {t.chars} ·{' '}
                    {fetched.durationMs} ms
                  </span>
                )}
                {fetched?.error && <span>{fetched.error}</span>}
              </div>
              <div className="row">
                {source.racesCited} {t.citedBy}
              </div>
            </article>
          );
        })}
      </div>

      <p className="disclaimer">{t.disclaimer}</p>
    </section>
  );
}
